import { CheckCircle, Award, Users, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useInView } from "../hooks/useInView";

const WhyChooseUs = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView(0.15);

  const reasons = [
    {
      id: "quality",
      icon: CheckCircle,
      title: t('why.quality'),
      description: t('why.qualityDesc')
    },
    {
      id: "experience",
      icon: Award,
      title: t('why.experience'),
      description: t('why.experienceDesc')
    },
    {
      id: "team",
      icon: Users,
      title: t('why.team'),
      description: t('why.teamDesc')
    },
    {
      id: "ontime",
      icon: Clock,
      title: t('why.ontime'),
      description: t('why.ontimeDesc')
    }
  ];

  return (
    <section ref={ref} className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className={`anim-heading text-4xl md:text-5xl font-bold text-gray-900 mb-4 ${inView ? 'is-in' : ''}`}>
            {t('why.title')}
          </h2>
          <div className="flex justify-center mb-4">
            <div className={`anim-heading-underline ${inView ? 'is-in' : ''}`} />
          </div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('why.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, idx) => {
            const IconComponent = reason.icon;
            return (
              <div
                key={reason.id}
                className={`anim-card anim-fade-up text-center group ${inView ? 'is-in' : ''}`}
                style={{ animationDelay: `${idx * 0.15}s` }}
              >
                <div className="anim-icon-circle inline-flex items-center justify-center w-16 h-16 bg-[#1a7a8a] rounded-full mb-4 group-hover:bg-[#156a78] transition-colors duration-300">
                  <IconComponent className="text-white" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {reason.title}
                </h3>
                <p className="text-gray-600">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
